
import { JsonProperty, Serializable } from "typescript-json-serializer";
/**
 * @description
 * QPSON地址信息
 */

@Serializable()
export class Address {
    @JsonProperty()
    id: number;
    @JsonProperty()
    countryCode2: string = "";
    @JsonProperty()
    countryName: string = "";
    @JsonProperty()
    state: string = "";
    @JsonProperty()
    stateCode?: string;
    @JsonProperty()
    city: string = "";
    // 区/县
    @JsonProperty()
    suburb?: string;
    @JsonProperty()
    streetAddress1: string = "";
    @JsonProperty()
    streetAddress2?: string;
    @JsonProperty()
    postcode?: string;
    @JsonProperty()
    firstName: string = "";
    @JsonProperty()
    lastName: string;
    @JsonProperty()
    mobile?: string = "";
    @JsonProperty()
    telephone: string = "";
    @JsonProperty()
    emailAddress: string = "";
    @JsonProperty()
    locationType: string = "";
    @JsonProperty()
    company: string;
    @JsonProperty()
    gender: string;
    @JsonProperty()
    partnerId: number;
    @JsonProperty()
    isDefault: boolean;
    @JsonProperty()
    isSelected: boolean;
    @JsonProperty()
    label: Array<string>;
}